import { render } from "./receive_edit_view_delete.vue?vue&type=template&id=b08b0184&scoped=true"
import script from "./receive_edit_view_delete.vue?vue&type=script&lang=js"
export * from "./receive_edit_view_delete.vue?vue&type=script&lang=js"

import "./receive_edit_view_delete.vue?vue&type=style&index=0&id=b08b0184&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b08b0184"]])

export default __exports__